import Cookies from "js-cookie";
import { createRoot } from "react-dom/client";
import React from "react";
import Footer from "./footer.jsx";
import * as http from "./http.ts";
import Nav from "./nav.jsx";
import RegisterFlow from "./register.jsx";
import { WPReportLoader, WPReportSearch } from "./report.jsx";
import { WorkPartyMap, WorkPartySearch } from "./search.jsx";
import { Modal } from "./utils.jsx";
import {
  WorkPartyCrewCorner,
  WorkPartyDocuments,
  WorkPartyPreregDocuments,
  WorkPartyStatus,
} from "./workparty.jsx";
import YouthApplicationFlow from "./youth-application.jsx";

const components = {
  Footer,
  Modal,
  Nav,
  RegisterFlow,
  WPReportLoader,
  WPReportSearch,
  WorkPartyCrewCorner,
  WorkPartyDocuments,
  WorkPartyMap,
  WorkPartyPreregDocuments,
  WorkPartySearch,
  WorkPartyStatus,
  YouthApplicationFlow,
};
const roots = new WeakMap();
window.vmsHttp = http;

window.render_react = (function () {
  var parseSessionCookie = function (session_cookie) {
    var session;
    if (session_cookie) {
      // URL-safe base64
      session_cookie = session_cookie.replace(/\-/g, "+").replace(/\_/g, "/");
      session_cookie += "=".repeat((4 - (session_cookie.length % 4)) % 4);
      // First 64 chars is the sha-512 server signature
      // Payload is [accessed, created, data]
      try {
        var bytes = Uint8Array.from(atob(session_cookie), function (char) {
          return char.charCodeAt(0);
        });
        session = JSON.parse(new TextDecoder().decode(bytes.slice(64)))[2];
      } catch (e) {}
    }
    return session || {};
  };

  var session_cookie = Cookies.get("session");
  var session = session_cookie ? parseSessionCookie(session_cookie) : null;

  var strings = {};
  var nav_data = null;

  var render_react = function (containers, cmp_name) {
    if (containers === undefined) {
      containers = document.querySelectorAll("[data-react-component]");
    } else if (containers instanceof Element) {
      containers = [containers];
    }
    Array.from(containers).forEach(function (container) {
      var component_name =
        cmp_name || container.getAttribute("data-react-component");
      var props_json = container.getAttribute("data-react-props");
      var props = props_json ? JSON.parse(props_json) : {};
      props.user = session ? session.user : null;
      // These two values are looked up in the context of the closure in
      // which this render_react is called, so when we update them via
      // ajax below and call this function again, they will be updated
      // with the right values.
      props.strings = strings;
      props.nav_data = nav_data;

      var component = components[component_name];
      if (component === undefined) {
        throw "Component not defined: " + component_name;
      }
      if (!container.hasAttribute("orig-children")) {
        container.setAttribute("orig-children", container.innerHTML);
      }
      props.translation = container.getAttribute("orig-children");
      var element = React.createElement(component, props);
      var root = roots.get(container);
      if (!root) {
        root = createRoot(container);
        roots.set(container, root);
      }
      root.render(element);
    });
  };

  http.setCsrfToken(session && session._csrft_);

  // If a response updates the session, re-render components with new props.
  http.onComplete(function () {
    var new_session_cookie = Cookies.get("session");
    if (new_session_cookie != session_cookie) {
      session_cookie = new_session_cookie;
      session = new_session_cookie
        ? parseSessionCookie(new_session_cookie)
        : null;
      http.setCsrfToken(session && session._csrft_);
      setTimeout(render_react, 0);
    }
  });

  // fetch translations
  http.getJson(`${window.base_url}gettext.json`).then(function (data) {
    strings = data;
    render_react();
  });

  // fetch navigation and footer links
  if (window.cms_base_url) {
    var url = `${window.cms_base_url}nav.json`;
    http.getJson(url, { credentials: "include" }).then(function (data) {
      nav_data = data;
      render_react();
    });
  }

  // render react components on page load
  render_react();
  return render_react;
})();
